module.exports = __webpack_public_path__ + "img/10.af3ff840.png";